import { FC } from 'react';
import { INavItem } from "../index";
import { FontAwesomeIcon } from 'src/constants/fontAwesomeIcons';
import { Link } from 'react-router-dom';

import './Breadcrumb.scss';

interface IBreadcrumbProps {
    breadcrumb: INavItem;
}

const Breadcrumb: FC<IBreadcrumbProps> = ({
    breadcrumb
}) => {

    const content = <>
        {breadcrumb.icon && <FontAwesomeIcon icon={breadcrumb.icon} />}
        <span>{breadcrumb.title}</span>
    </>;

    return breadcrumb.url ? (
        <Link 
            className="ngt-breadcrumb"
            to={breadcrumb.url}
        >
            {content}
        </Link>
    ) : <span className="ngt-breadcrumb">{content}</span>;
}


export default Breadcrumb;
